/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable import/no-cycle */
import React, { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import { ListingPageInterface } from './listingPageTypes';
import Listing from '../../pageParts/listing/listing';
import Line from '../../UI/line/line';
import style from './listingPage.module.scss';
import { ListingDataInterface, MODAL_TYPES } from '../../constants/constants';
import PopUpLogin from '../../pageParts/popUp/popUpLogin';
import PopUpDelete from '../../pageParts/popUp/popUpDelete';
import PopUpRegistration from '../../pageParts/popUp/popUpRegistration';
import { updateListing } from '../../service/ListingData';
import { useDispatch } from '../..';

const ListingPage: React.FC<ListingPageInterface> = ({
  data,
  isLogin,
  toDelete,
  toEdit,
  toLogin,
  modal,
  loginType,
  closePopupRegistration,
  afterLogin,
  afterRegistration,
  onNoAccount,
  closePopupLogin,
  returnToLogin,
}) => {
  const [isModal, setIsModal] = useState<MODAL_TYPES | null>(null);
  const dispatch = useDispatch();
  const resolution = {
    DesktopOrLaptop: useMediaQuery({ minWidth: 620 }),
    mobile: useMediaQuery({ maxWidth: 620 }),
  };
  useEffect(() => {
    setIsModal(modal);
  }, [modal]);

  const toAccept = () => setIsModal(MODAL_TYPES.DELETE);
  const toCancel = () => setIsModal(null);
  const acceptingDelete = () => {
    toDelete(data.id);
    setIsModal(null);
  };

  return (
    <div className={style.listingpageStyle}>
      <Line width={1320} height={1} />
      <Listing
        data={data}
        isLogin={isLogin}
        toDelete={toAccept}
        toEdit={toEdit}
        toLogin={toLogin}
      />
      <Line width={1320} height={1} />
      {isModal === MODAL_TYPES.LOG_IN && (
        <div
          className={resolution.DesktopOrLaptop ? style.modal : style.modalMob}
        >
          <PopUpLogin
            type={loginType}
            error={false}
            onClose={closePopupLogin}
            onNoAccount={onNoAccount}
            onSubmit={afterLogin}
          />
        </div>
      )}
      {isModal === MODAL_TYPES.DELETE && (
        <div
          className={resolution.DesktopOrLaptop ? style.modal : style.modalMob}
        >
          <PopUpDelete
            onAccept={acceptingDelete}
            onCancel={toCancel}
            onClose={toCancel}
          />
        </div>
      )}
      {isModal === MODAL_TYPES.REGISTRATION && (
        <div
          className={resolution.DesktopOrLaptop ? style.modal : style.modalMob}
        >
          <PopUpRegistration
            error={false}
            onClose={closePopupRegistration}
            toLogin={returnToLogin}
            onSubmit={afterRegistration}
          />
        </div>
      )}
    </div>
  );
};

export default ListingPage;
